import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { graphql } from 'src/generated';
import {
  BoardTableDataQuery,
  BoardTableDataQueryVariables,
} from 'src/generated/graphql';

export const boardTableViewDataDoc = graphql(`
  query BoardTableData($boardId: ID!, $tableId: ID!) {
    table(input: { boardId: $boardId, tableId: $tableId }) {
      ...Table
      columns {
        ...TableColumn
      }
      views {
        ...tableView
        columns {
          ...TableViewColumn
        }
      }
      activeAutomations
      owner
    }
  }
`);

export type BoardTableQueryResult = BoardTableDataQuery['table'];

export const useBoardTableQuery = ({
  boardId,
  tableId,
}: BoardTableDataQueryVariables) => {
  const { data, loading, error } = useQuery(boardTableViewDataDoc, {
    fetchPolicy: 'cache-and-network',
    variables: {
      boardId,
      tableId,
    },
    skip: !boardId || !tableId,
  });

  const table = useMemo(() => {
    if (!data?.table) return null;
    const views = [...(data?.table?.views || [])];
    views.sort((a, b) => a.order - b.order);

    return {
      ...data?.table,
      views,
    };
  }, [data]);

  return {
    table,
    isBoardTableLoading: loading,
    isBoardTableError: error,
  };
};
